// This file was auto-generated by Fern from our API Definition.
export var WorkflowRevisionDataInput;
(function (WorkflowRevisionDataInput) {
    WorkflowRevisionDataInput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(WorkflowRevisionDataInput || (WorkflowRevisionDataInput = {}));
